import * as storageService from "@trueskin-web/services/src/storage"

const FALTEN_QUESTIONNAIRE_ID = "Ykat95xJqBKI5xtyFWxe"
const LABEL_FOR_EXCLUDE = "Ich bin mir unsicher – bitte um Hilfe"

export function getFaltenSubTreatmentGoalList({ isFull = false } = {}) {
  const storageKeys = storageService.getStorageKeys()

  const idForCompare = storageService.getItem({
    id: storageKeys.VWO_INITIAL_QUESTIONNARE_ID,
  })

  if (idForCompare !== FALTEN_QUESTIONNAIRE_ID) return

  const { SubTreatmentGoal } =
    storageService.getItem({
      id: storageKeys.INITIAL_ANSWERS,
    }) || {}

  if (!SubTreatmentGoal) return

  const filteredSubTreatmentGoal = SubTreatmentGoal.split(",").filter(
    (goal) => goal.trim() !== LABEL_FOR_EXCLUDE
  )

  if (isFull) return filteredSubTreatmentGoal

  const shortResponse = filteredSubTreatmentGoal.splice(0, 4)
  if (filteredSubTreatmentGoal.length)
    shortResponse.push(`+${filteredSubTreatmentGoal.length}`)

  return shortResponse
}
